const RESPONSIVE_MODE = {
    FIT_TO_SCREEN: 'FIT_TO_SCREEN',
    SET_ITEMS_PER_ROW: 'SET_ITEMS_PER_ROW',
};
export default RESPONSIVE_MODE;
//# sourceMappingURL=layoutParams_structure_responsiveMode.js.map